import React from "react";
import Lottie from "lottie-react";

// Import your Lottie JSON files
import homeAnim from "../assets/nav/home.json";
import aboutAnim from "../assets/nav/about.json";
import projectsAnim from "../assets/nav/projects.json";
import contactAnim from "../assets/nav/contact.json";
import githubAnim from "../assets/nav/github.json";
import linkedinAnim from "../assets/nav/linkedin.json";

function Header() {
  const navLinks = [
    { id: "home", icon: homeAnim },
    { id: "about", icon: aboutAnim },
    { id: "projects", icon: projectsAnim },
    { id: "contact", icon: contactAnim },
  ];

  const socialLinks = [
    {
      url: "https://github.com/kdgohil01",
      icon: githubAnim,
    },
    {
      url: "https://www.linkedin.com/in/karmadeepsinh-gohil-31484230a/?originalSubdomain=in", 
      icon: linkedinAnim,
    },
  ];

  return (
    <header className="fixed top-0 left-0 w-full bg-white shadow z-50">
      <div className="max-w-7xl mx-auto px-4 py-3 flex justify-between items-center">
        {/* Logo or Heading */}
        <h1 className="text-sm sm:text-xl font-bold text-blue-600">
          On a Journey of Learning and Building
        </h1>

        {/* Nav Icons */}
        <nav className="flex space-x-4 sm:space-x-6 items-center">
          {navLinks.map((link, index) => (
            <a
              key={index}
              href={`#${link.id}`}
              title={link.id.charAt(0).toUpperCase() + link.id.slice(1)}
              className="group relative flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-full hover:scale-110 transition-transform duration-300"
            >
              <Lottie
                animationData={link.icon}
                loop={true}
                className="w-full h-full bounce-slow"
              />
              <span className="absolute -bottom-6 text-xs text-gray-500 opacity-0 group-hover:opacity-100 transition">
                {link.id}
              </span>
            </a>
          ))}

          {/* Social Icons */}
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              title="External Link"
              className="group relative flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-full hover:scale-110 transition-transform duration-300"
            >
              <Lottie
                animationData={social.icon}
                loop={true}
                className="w-full h-full bounce-slow"
              />
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
}

export default Header;
